import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';

import { ApContentService } from '@ap/content';

import content from './conversational-chat-retryconnectionerror.content.json';

@Component({
    selector: 'conversational-chat-retryconnectionerror',
    templateUrl: './conversational-chat-retryconnectionerror.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConversationalChatRetryconnectionerrorComponent {
    private readonly apContentService = inject(ApContentService);

    public readonly refreshComponent = output<void>();

    public setRefreshComponent(): void {
        this.refreshComponent.emit();
    }

    public constructor() {
        this.apContentService.addContentItems(content);
    }
}
